// extracted by mini-css-extract-plugin
export default {"card":"s0-z","carouselContainer":"t0-z","carouselContent":"u0-z"};